/**
 * @freesewing/plugin-sprinkle | v2.16.2
 * A FreeSewing plugin to bulk-add snippets to your pattern
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var e={name:"@freesewing/plugin-sprinkle",version:"2.16.2",hooks:{preRender:function(e){!1===e.attributes.get("freesewing:plugin-sprinkle")&&e.attributes.set("freesewing:plugin-sprinkle","2.16.2")}},macros:{sprinkle:function(e){for(let n of e.on)this.snippets[n+"-"+e.snippet]=new this.Snippet(e.snippet,this.points[n])}}};export default e;
//# sourceMappingURL=index.mjs.map
